import { Button, Col, Popover, Row } from 'antd'
import { ClockCircleFilled, EnvironmentOutlined } from '@ant-design/icons'
import { DataItem } from '@gravitate-js/excalibrr'
import type React from 'react'
import { useSecurityContext } from '@components/Navigation/SecurityContext'

type DispatchStorePopoverProps = {
  destinations: Gravitate.OrderDrop[]
  setOrderHistoryStoreId?: (store_id: string) => void
  hoverComponent?: React.ReactNode
}

export const DispatchStorePopover = ({
  destinations,
  setOrderHistoryStoreId,
  hoverComponent = null,
}: DispatchStorePopoverProps) => {
  const { scopes } = useSecurityContext()
  const isCarrier = scopes.is_carrier

  const content = (
    <>
      {destinations.map((d, i) => (
        <div className='mb-3' key={i}>
          <Row>
            <Col span={12}>
              <b className='order-destination-location'>
                <EnvironmentOutlined className='pr-2' />
                <b>{`${d.store_name || ''} (${d.location_name})`}</b>
              </b>
            </Col>
            <Col span={12}>
              <b className='order-destination-city-state vertical-flex-center'>
                {d.city && d.city.trim() !== '' ? ` ${d.city}` : ''}
                {d.state && d.state.trim() !== '' ? `, ${d.state}` : ''}
              </b>
            </Col>
          </Row>

          <Row>
            <Col span={12}>
              <DataItem label='Site Address'>{d.address && d.address.trim() !== '' ? d.address : 'N/A'}</DataItem>
            </Col>
            <Col span={12}>
              <DataItem label='Contact Number'>
                <span className='order-destination-contact-number'>
                  {d.phone && d.phone.trim() !== '' ? d.phone : 'N/A'}
                </span>
              </DataItem>
            </Col>
          </Row>
        </div>
      ))}
    </>
  )
  return (
    <>
      <Popover
        content={content}
        title={
          <Row>
            <Col span={12}>Destination Details</Col>
            <Col span={12}>
              {setOrderHistoryStoreId && !isCarrier && (
                <Button
                  type='link'
                  onClick={() => setOrderHistoryStoreId(destinations[0].store_id)}
                  icon={<ClockCircleFilled />}
                >
                  View Recent Orders
                </Button>
              )}
            </Col>
          </Row>
        }
        trigger='hover'
      >
        {hoverComponent ? (
          hoverComponent
        ) : destinations.length > 1 ? (
          <b>{destinations.length} More</b>
        ) : (
          <b className='text-ellipsis'>{destinations[0]?.location_name}</b>
        )}
      </Popover>
    </>
  )
}
